import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=5d5e865f&scoped=true"
import script from "./edit.vue?vue&type=script&%3Aroute=%7Bpath%3A%20'%2Fflow%2Fedit%2F%3Aid'%2CnoChkout%3A%20true%7D&lang=js"
export * from "./edit.vue?vue&type=script&%3Aroute=%7Bpath%3A%20'%2Fflow%2Fedit%2F%3Aid'%2CnoChkout%3A%20true%7D&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=5d5e865f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e865f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
